import type { AppContextState } from './types';

export const initialState: AppContextState = {
  domainZone: 'ru',
  deviceInfo: {
    mobileOS: null,
    browser: { name: 'other', version: '0.0', isPwaMode: false },
    ua: '',
  },
};
